import { Suspense } from "react";
import "./App.css";
import "./common/common_css/Common_Css.css";
import "./common/common_css/Common_Modal_css.css";
import "./common/common_css/Common_tab_css.css";
import "./common/common_css/Form.css";
import "./common/common_css/Orders.css";
import "./common/common_css/Payments.css";

import { Spinner } from "react-bootstrap";
import { Route, Routes } from "react-router-dom";
import Login from "./components/login/Login";
import DefaultLayout from "./layout/DefaultLayout";

function App() {
  return (
    <>
      <Suspense
        fallback={
          <div className="d-flex justify-content-center align-items-center vh-100">
            <Spinner
              animation="border"
              style={{ color: "var(--al-primary-600)" }}
            />
          </div>
        }
      >
        <Routes>
          <Route exact path="/" name="Login Page" element={<Login />} />
          {/* <Route exact path="/404" name="Page 404" element={<Page404 />} /> */}
          {/* <Route exact path="/500" name="Page 500" element={<Page500 />} /> */}
          <Route path="*" name="Home" element={<DefaultLayout />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
